import { DefaultRole } from '@src/types/common';
import { UserListParams } from '@src/views/userList/store/userList';
import { NewUserData } from './usersApi';
import { oliveApi } from '../index';

const url = `/admin/v1/users`;

const createUserApi = async (data: NewUserData): Promise<any> => {
  return await oliveApi.POST<NewUserData, any>(`${url}`, { ...data });
};

const getUserListApi = async (params: UserListParams): Promise<any> => {
  return await oliveApi.GET<UserListParams, any>(`${url}`, {
    ...params,
  });
};

const getUserByIdApi = async (id: number): Promise<any> => {
  return await oliveApi.GET<any, any>(`${url}/${id}`);
};

const updateUserByIdApi = async <T, U>(id: number, data: T): Promise<any> => {
  return await oliveApi.PATCH<T, U>(`${url}/${id}`, { ...data });
};

const deleteUserByIdApi = async (id: number): Promise<any> => {
  return await oliveApi.DELETE<any, any>(`${url}/${id}`);
};

const getCompanyListByUserIdApi = async (id: number) => {
  return await oliveApi.GET<any, any>(`${url}/${id}/managers`);
};

const authorizeAdminByUserIdApi = async (
  id: number,
  data: { role: DefaultRole }
) => {
  return await oliveApi.PATCH<any, any>(`${url}/${id}/role`, { ...data });
};

export {
  getUserListApi,
  createUserApi,
  getUserByIdApi,
  updateUserByIdApi,
  deleteUserByIdApi,
  getCompanyListByUserIdApi,
  authorizeAdminByUserIdApi,
};
